/* Wingmate product template – small enhancements (loaded only by that template).
   1. Video section: Play/Pause button + autoplay only while visible.
   2. Testimonials: centred, looping carousel with prev/next arrows, dots and swipe
      (cards are cloned at both ends so the loop is seamless, like the reference). */
(function () {
  'use strict';

  /* ---------- 1. Video Play/Pause ---------- */
  document.querySelectorAll('.kc-action').forEach(function (root) {
    var video = root.querySelector('.kc-action__video');
    var btn = root.querySelector('.kc-action__control');
    if (!video || !btn) return;

    var userPaused = false;

    function sync() {
      btn.textContent = video.paused ? btn.getAttribute('data-play') : btn.getAttribute('data-pause');
      btn.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
    }

    btn.addEventListener('click', function () {
      if (video.paused) {
        userPaused = false;
        video.play().catch(function () {});
      } else {
        userPaused = true;
        video.pause();
      }
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!userPaused) video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      ).observe(video);
    }
  });

  /* ---------- 2. Testimonials carousel ---------- */
  document.querySelectorAll('.wm-testi').forEach(function (root) {
    var viewport = root.querySelector('.wm-testi__viewport');
    var track = root.querySelector('.wm-testi__track');
    var prev = root.querySelector('.wm-testi__btn--prev');
    var next = root.querySelector('.wm-testi__btn--next');
    var dotsWrap = root.querySelector('.wm-testi__dots');
    if (!viewport || !track || !prev || !next || !dotsWrap) return;

    var originals = Array.prototype.slice.call(track.children);
    var n = originals.length;
    if (n < 2) return;

    /* clone one full set before and after the originals */
    originals.forEach(function (card) {
      var c = card.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('wm-testi__card--clone');
      track.appendChild(c);
    });
    for (var k = n - 1; k >= 0; k--) {
      var c2 = originals[k].cloneNode(true);
      c2.setAttribute('aria-hidden', 'true');
      c2.classList.add('wm-testi__card--clone');
      track.insertBefore(c2, track.firstChild);
    }
    var all = Array.prototype.slice.call(track.children); // 3n cards
    var index = n; // position in `all`; originals live at [n, 2n)
    var animating = false;

    var dots = originals.map(function (card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'wm-testi__dot';
      dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
      dot.addEventListener('click', function () {
        goTo(n + i);
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    viewport.classList.add('is-ready');

    function offsetFor(i) {
      var card = all[i];
      return card.offsetLeft - (viewport.clientWidth - card.offsetWidth) / 2;
    }

    function render(noTransition) {
      if (noTransition) track.classList.add('no-transition');
      track.style.transform = 'translateX(' + -offsetFor(index) + 'px)';
      if (noTransition) {
        // force reflow so the next transform animates again
        void track.offsetWidth;
        track.classList.remove('no-transition');
      }
      var active = ((index - n) % n + n) % n;
      dots.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === active);
        dot.setAttribute('aria-current', j === active ? 'true' : 'false');
      });
      all.forEach(function (card, j) {
        card.classList.toggle('is-active', j === index);
        card.classList.toggle('is-near', Math.abs(j - index) === 1);
      });
    }

    function goTo(i) {
      if (animating) return;
      animating = true;
      index = i;
      render(false);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      animating = false;
      // jumped into a clone set: snap back to the equivalent original silently
      if (index < n) {
        index += n;
        render(true);
      } else if (index >= 2 * n) {
        index -= n;
        render(true);
      }
    });

    prev.addEventListener('click', function () {
      goTo(index - 1);
    });
    next.addEventListener('click', function () {
      goTo(index + 1);
    });

    /* swipe */
    var startX = null;
    viewport.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
    });
    viewport.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? index + 1 : index - 1);
    });
    viewport.addEventListener('pointercancel', function () {
      startX = null;
    });

    window.addEventListener('resize', function () {
      render(true);
    });
    render(true);
    // re-render once fonts/images settle so widths are final
    window.addEventListener('load', function () {
      render(true);
    });
  });
})();
